import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { shallow } from "zustand/shallow";

import useDashboardStore from "@/state/dashboard";

import useAdditionalLocale from "@/hooks/App/useAdditionalLocale";

import locales from "./locales";
import WidgetContainer from "@/components/WidgetContainer/WidgetContainer";
import { Responsive, WidthProvider } from "react-grid-layout";
import { convertMasterFacilitiesListFromSqlView, pull } from "../utils";
import useMetadataStore from "@/state/metadata";
import Widget1 from "./widgets/Widget1";
import ConfigControl from "./components/ConfigControl/ConfigControl";
const ReactGridLayout = WidthProvider(Responsive);

export const INIT_MASTER_FACILITIES_LIST_STATE = {
  columns: [],
  filter: null,
  sort: null,
  paging: {
    pageSize: 100,
    page: 1,
  },
};

const Dashboard8 = () => {
  useAdditionalLocale("en", locales.en);
  useAdditionalLocale("lo", locales.lo);
  const { t } = useTranslation();
  const { oupProgram } = useMetadataStore(
    (state) => ({ oupProgram: state.oupProgram }),
    shallow
  );
  const changeAdditionalStateProperty = useDashboardStore(
    (state) => state.changeAdditionalStateProperty
  );

  useEffect(() => {
    (async () => {
      try {
        changeAdditionalStateProperty("dashboard8Ready", false);
        const resultData = await pull("/api/getDashboard8Data");

        const data = convertMasterFacilitiesListFromSqlView(
          resultData.data,
          oupProgram
        );
        changeAdditionalStateProperty("dashboard8Data", data);
      } catch (error) {
        console.error(error);
        changeAdditionalStateProperty("dashboard8Data", []);
      } finally {
        changeAdditionalStateProperty("dashboard8Ready", true);
      }
    })();
  }, []);

  const [height, setHeight] = useState(window.innerHeight - 80);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 80);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <ReactGridLayout
      isDraggable={false}
      breakpoints={{ desktop: 1200, mobile: 480 }}
      layouts={{
        desktop: [{ i: "1", x: 0, y: 0, w: 12, h: 1, static: true }],
        mobile: [{ i: "1", x: 0, y: 0, w: 12, h: 1, static: true }],
      }}
      cols={{ desktop: 12, mobile: 6 }}
      rowHeight={height}
      containerPadding={[0, 0]}
    >
      <WidgetContainer
        key="1"
        dashboardIndex={6}
        widgetIndex={0}
        controlButtons={[<ConfigControl />]}
        childrenWidgets={[
          {
            title: t("dashboard8_widget1_title"),
            widget: <Widget1 />,
          },
        ]}
      />
    </ReactGridLayout>
  );
};

export default Dashboard8;
//backup old version
// import { useEffect } from "react";
// import { useTranslation } from "react-i18next";
// import { shallow } from "zustand/shallow";

// import useDashboardStore from "@/state/dashboard";
// import usePrepareDataForTab345 from "./hooks/usePrepareDataForTab345";

// import LineListLayout from "./layouts/LineListLayout";
// import ServiceDeliveryUnitsLayout from "./layouts/ServiceDeliveryUnitsLayout";
// import useAdditionalLocale from "@/hooks/App/useAdditionalLocale";
// import AccessAndInfrastructureLayout from "./layouts/AccessAndInfrastructureLayout";

// import locales from "./locales";

// const Dashboard8 = () => {
//   useAdditionalLocale("en", locales.en);
//   useAdditionalLocale("lo", locales.lo);
//   const { t } = useTranslation();
//   const { selectWidgetChild, dashboardState, changeAdditionalStateProperty, additionalState } = useDashboardStore(
//     (state) => ({
//       selectWidgetChild: state.selectWidgetChild,
//       dashboardState: state.dashboardState,
//       changeAdditionalStateProperty: state.changeAdditionalStateProperty,
//       additionalState: state.additionalState
//     }),
//     shallow
//   );

//   const { dashboardOupSelectedTab } = additionalState;
//   const prepareData = usePrepareDataForTab345();

//   useEffect(() => {
//     changeAdditionalStateProperty("dashboardOupSelectedTab", 0);
//   }, []);

//   switch (dashboardOupSelectedTab) {
//     case 0:
//     case 1:
//     case 4:
//       return <LineListLayout />;
//     case 2:
//       return <ServiceDeliveryUnitsLayout {...prepareData} />;
//     case 3:
//       return <AccessAndInfrastructureLayout {...prepareData} />;
//     default:
//       return <div>to be filled</div>;
//   }
// };

// export default Dashboard8;
